import { useEffect, useRef, useState } from "react"
import { v4 } from "uuid"
import { ScrollTrigger, useGSAP } from "@repo/utils/gsap"
import { useNavigation } from "../providers/NavigationProvider"

//TODO: fix this fucking not predictable shit
//tends to make st jump

export default function useInView({
	id: passedId = "",
	pinnedContainer = undefined,
	disabled = false,
	once = true,
	trigger = { start: "center bottom", end: "center bottom" },
	progress = null,
	markers = false,
	pin = false,
	pinSpacing = true,
	revert = true,
}) {
	const ref = useRef(null)
	const [uuid] = useState(() => v4())
	const [inView, setInView] = useState(disabled)
	const [above, setAbove] = useState(false)
	const [under, setUnder] = useState(true)
	const [id] = useState(() => `trigger-${passedId}-${uuid}`)
	const [intersected, setIntersected] = useState(disabled)
	const isLoaded = useNavigation((state) => state.isLoaded)
	const isTransitionCompleted = useNavigation((state) => state.isTransitionCompleted)
	//TODO: investigate for better props handling, in general passing extra props (like pinnedContainer) breaks logic
	//TODO: can reproduce with global update like theme color scheme, sometimes update caused jumping back up so the user
	//TODO: couldn't scroll to the very end of the page
	//TODO: components with this issue: PinnedTextWithImage & ProjectSlider

	//this state is a workaround for a weird bug where ref.current disappears from useGSAP callback after rerender
	//supports only stable ref
	const [el, setEl] = useState(null)
	useEffect(() => {
		setEl(ref.current)
	}, [])

	useGSAP(
		() => {
			if (disabled || !isLoaded || !isTransitionCompleted || !el) return
			ScrollTrigger.create({
				id,
				trigger: el,
				start: `${trigger.start}`,
				end: `${trigger.end}`,
				markers,
				// markers: true,
				pin,
				pinSpacing,
				invalidateOnRefresh: true,
				once,
				pinnedContainer: pinnedContainer?.current,
				onEnter: () => {
					setAbove(false)
					setUnder(false)
					setIntersected(true)
				},
				onEnterBack: () => {
					setAbove(false)
					setUnder(false)
					setIntersected(true)
				},
				onLeave: () => {
					setAbove(true)
					setUnder(false)
				},
				onLeaveBack: () => {
					setAbove(false)
					setUnder(true)
				},
				onUpdate: ({ progress: stProgress, isActive }) => {
					setInView(isActive)
					setIntersected(true)
					if (progress) {
						progress.current = stProgress
					}
				},
			})
		},
		{
			dependencies: [disabled, isLoaded, isTransitionCompleted, el],
			revertOnUpdate: revert,
			scope: ref,
		},
	)

	return { ref, inView, under, above, intersected }
}
